import React, { useState } from "react";
import { Grid, IconButton, Tooltip } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import ConfirmPopup from "app/common/Component/Popup/ConfirmPopup";
import IconDelete from "app/common/Icon/IconDelete";
import { RELATIONSHIP_TYPES } from "app/common/LocalConst";
import { hideMiddleDigits } from "app/common/LocalFunction";
import { useFormikContext } from "formik";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import PopupRelatedPerson from "app/PatientManagement/PatientList/Popup/PopupRelatedPerson";

const ListRelatedPerson = observer(({ isMobile }) => {
    const { values, setFieldValue } = useFormikContext();
    const { t } = useTranslation();
    const [openPopup, setOpenPopup] = useState(false);
    const [openConfirmDelete, setOpenConfirmDelete] = useState(null);

    const handleDelete = () => {
        if (openConfirmDelete !== null) {
            const arr = values.relatedPersons || [];
            const updated = [...arr];

            if (updated[openConfirmDelete].id) {
                updated[openConfirmDelete] = {
                    ...updated[openConfirmDelete],
                    voided: true
                };
            } else {
                updated.splice(openConfirmDelete, 1);
            }

            setFieldValue("relatedPersons", updated);
            setOpenConfirmDelete(null);
        }
    };

    const handleAdd = (rel) => {
        const arr = values.relatedPersons || [];
        setFieldValue("relatedPersons", [...arr, rel]);
        setOpenPopup(false);
    };

    return (
        <div style={{ backgroundColor: "white", padding: "10px", width: "100%" }}>
            <Grid container spacing={1}>
                <Grid item xs={12} className="flex align-center flex-end gap-1 cursor">
                    <Tooltip title="Thêm mối quan hệ">
                        <IconButton size="small" style={{ color: "#eb7d15" }} onClick={() => setOpenPopup(true)}>
                            <Add className="font-md" />
                        </IconButton>
                    </Tooltip>
                    <span className="button-more pointer" onClick={() => setOpenPopup(true)}>
                        Thêm mối quan hệ
                    </span>
                </Grid>
                <Grid item xs={12}>
                    {(values?.relatedPersons || []).map((item, index) => {
                        if (item.voided) return null;
                        const related = item?.relatedPatient || {};
                        const relationshipName = RELATIONSHIP_TYPES.find(r => r.value === item.relationship)?.name || 'Không xác định';

                        return (
                            <div key={index} style={{ borderBottom: "1px solid gray", display: "flex", justifyContent: "space-between", padding: "8px" }}>
                                <div>
                                    <div className="flex gap-2 items-center">
                                        <span style={{ fontWeight: 600 }}>{relationshipName}</span>
                                        <span style={{ color: "#666" }}>{related?.code || ''}</span>
                                    </div>
                                    <div style={{ marginTop: '8px', color: '#333' }}>
                                        <b>{related?.displayName || 'Không có tên'}</b>
                                        {related?.phoneNumber && <span style={{ marginLeft: "8px", color: '#666' }}>({hideMiddleDigits(related.phoneNumber)})</span>}
                                    </div>
                                </div>
                                <div className="flex justify-center items-center">
                                    <Tooltip title="Xóa mối quan hệ">
                                        <div className="cursor pointer" onClick={() => setOpenConfirmDelete(index)}>
                                            <IconDelete />
                                        </div>
                                    </Tooltip>
                                </div>
                            </div>
                        );
                    })}
                </Grid>
            </Grid>
            {openPopup && (
                <PopupRelatedPerson
                    open={openPopup}
                    handleClose={() => setOpenPopup(false)}
                    handleAdd={handleAdd}
                />
            )}
            {openConfirmDelete !== null && (
                <ConfirmPopup
                    open={true}
                    onClose={() => setOpenConfirmDelete(null)}
                    text="Bạn có chắc chắn muốn xóa mối quan hệ này không?"
                    onConfirm={handleDelete}
                />
            )}
        </div>
    );
});

export default ListRelatedPerson;
